import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import PageHeader from "../../shared/page-header/PageHeader";
import { getApiBaseUrl } from "../../utils/apiConfig";
import { getStorageValues } from "../../shared/CommonFunctions";
import axios from "axios";

function UserProfile(props) {
  const [userProfile, setUserProfile] = React.useState([]);

  function handleChange(e) {
    const { name, value } = e.currentTarget;
    setUserProfile((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    fetchUserProfile();
  }, []);

  const fetchUserProfile = async () => {
    try {
      let registerDetails = {
        UserId: getStorageValues('userId')
      };
      const response = await axios.get(getApiBaseUrl() + "/getUserProfile", { params: registerDetails});
      if (response.status === 200) {
        setUserProfile(response.data.data[0][0]);
      }
    } catch (error) {
      console.log(error);
    }
  };
  
  return (
    <>
    
      <PageHeader 
        displayModule={props.Module}
        showPDF={false}
        showExcel={false}
        showPrint={false}
        showRefresh={false}
        showAddButton={false}
      />

        <div className="card">
          <div className="card-body">
            <div className="profile-set">
              <div className="profile-head">
              </div>
              <div className="profile-top">
                <div className="profile-content">
                  <div className="profile-contentimg">
                    <img src="../assets/img/customer/customer5.jpg" alt="img" id="blah"/>
                      <div className="profileupload">
                        <input type="file" id="imgInp"/>
                          <Link to=""><img src="../assets/img/icons/edit-set.svg" alt="img"/></Link>                          
                      </div>  
                  </div>
                  <div className="profile-contentname">
                    <h3>William Castillo</h3>
                    <h4>Updates Your Photo and Personal Details.</h4>
                  </div>
                </div>

              </div>
            </div>
            <div className="row">
              <div className="col-lg-6 col-sm-12">
                <div className="mb-3">
                  <label className="form-label">Full Name</label>
                  <input 
                    type="text" 
                    name="FullName"
                    className="form-control"
                    value={userProfile.FullName} 
                    disabled
                  />
                </div>
              </div>
              <div className="col-lg-6 col-sm-12">
                <div className="mb-3">
                  <label className="form-label">User Name</label>
                  <input 
                    type="text" 
                    className="form-control" 
                    name="UserName"
                    value={userProfile.UserName}
                    disabled
                  />
                </div>
              </div>
              <div className="col-lg-6 col-sm-12">
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input type="text" className="form-control" name="Email" value={userProfile.Email} onChange={handleChange}/>
                </div>
              </div>
             
              <div className="col-lg-6 col-sm-12">
                <div className="mb-3">
                  <label className="form-label">Mobile No</label>
                  <input type="text" className="form-control" name="PhoneNumber" value={userProfile.PhoneNumber} onChange={handleChange}/>
                </div>
              </div>
              <div className="col-lg-12 col-sm-12">
                <div className="mb-3">
                  <label className="form-label">Address</label>
                  <input type="text" className="form-control" name="Address" value={userProfile.Address} onChange={handleChange}/>
                </div>
              </div>

              <div className="col-lg-4 col-sm-12">
                <div className="mb-3">
                  <label className="form-label">State / Province</label>
                  <input type="text" className="form-control" name="State" value={userProfile.State} onChange={handleChange}/>
                </div>
              </div>

              <div className="col-lg-4 col-sm-12">
                <div className="mb-3">
                  <label className="form-label">City</label>
                  <input type="text" className="form-control" name="City" value={userProfile.City} onChange={handleChange}/>
                </div>
              </div>

              <div className="col-lg-4 col-sm-12">
                <div className="mb-3">
                  <label className="form-label">Postal Code</label>
                  <input type="text" className="form-control"  name="PinNumber" value={userProfile.PinNumber} onChange={handleChange}/>
                </div>
              </div>

              <div className="col-12">
                <Link onClick={(e) => e.preventDefault()} className="btn btn-submit me-2">Submit</Link>                      
              </div>
            </div>
          </div>
        </div>
      
      
      
  
      
    </>
  );
}

export default UserProfile;
